module.exports = __webpack_public_path__ + "logo.svg?0f102d1c6da0b22b0a5d0ba293706a53";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.svg
// module id = 979
// module chunks = 0